<template>

  <div class="section fp-auto-height" style="overflow:visible">
    <app-social></app-social>
    <a :href="'#'+top" class="scroll-top">
      <v-btn fab absolute small >
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
    </a>
  </div>
  
</template>


<style lang="scss" scoped>
  .scroll-top{
    position:absolute;
    bottom:220px;
    right:60px;
    @media screen and (min-width:1350px){
      bottom:300px;
      right:80px;
    }
  }
</style>


<script>
  import appSocial from '../components/app-social.vue'

  export default{
    components:{
      appSocial
    },
    props:{
      top: String
    }
  }
</script>

